import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { transientOptions } from "@product/scmp-sdk";

import type { FooterVariant } from ".";

export type ContainerProps = {
  $variant?: `${FooterVariant}`;
};
export const Container = styled("div", {
  ...transientOptions,
})<ContainerProps>`
  ${props => {
    switch (props.$variant) {
      case "home":
      case "section":
        return css`
          background-color: #ffffff;
        `;
      default:
        return css`
          background-color: #222222;
        `;
    }
  }}
`;
